import type { ShipmentTypeConfig } from '../../../domain/types/configs/company/ShipmentTypeConfig';

export const shipmentTypeConfig: ShipmentTypeConfig = {
  shipmentType: [
    {
      value: "BBK",
      label: "Break Bulk",
      visible: true
    },
    {
      label: "Buyer's Consolidation",
      value: "BCN",
      visible: true
    },
    {
      value: "BLK",
      label: "Bulk",
      visible: true
    },
    {
      label: "Agent Consolidation",
      value: "CON",
      visible: true
    },
    {
      label: "FCL",
      value: "FCL",
      visible: true
    },
    {
      value: "FTL",
      label: "FTL",
      visible: true
    },
    {
      value: "LCL",
      label: "LCL",
      visible: true
    },
    {
      label: "Liquid",
      value: "LQD",
      visible: true
    },
    {
      label: "Loose",
      value: "LSE",
      visible: true
    },
    {
      label: "LTL",
      value: "LTL",
      visible: true
    },
    {
      label: "On Board Courier",
      value: "OBC",
      visible: true
    },
    {
      label: "Roll On/Roll Off",
      value: "ROR",
      visible: true
    },
    {
      value: "ULD",
      label: "Unit Load Device",
      visible: true
    },
    {
      value: "UNA",
      label: "Unaccompanied",
      visible: true
    }
  ]
}; 